import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ConicSectionCalculator from "./components/ConicSectionCalculator";
import { ThemeProvider } from "./components/ThemeProvider";

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="conic-ui-theme">
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ConicSectionCalculator />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;